import './footer-component.scss';
import { ButtonComponent } from '../button-component/button-component';
import { bridgeWarGui, environment } from '../../env';
import { classNames } from '../../utils/mixed';
import { engineButtonClicked } from '../../app-interfaces/actions/engineCommands';
import { settingsButton } from '../../app-interfaces/buttonsState';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import React from 'react';

export const FooterComponent: React.FC = () => {
    const { footerButtons, forceShowAllCards } = useAppSelector((state) => state.table);
    const dispatch = useAppDispatch();
    const { engineState } = useAppSelector((state) => state.app);
    return (
        <footer className={classNames('FooterComponent', engineState.service, bridgeWarGui && 'isBridgeWar')}>
            {Object.values(footerButtons).map((button) => (
                <ButtonComponent key={`${button.id} ${button.key}`} button={button} />
            ))}
            <ButtonComponent button={settingsButton} />
            {engineState.service === 'BetterBridgeClub' && (
                <div className="card-button" onClick={() => dispatch(engineButtonClicked({ id: 'showAll', value: true }))}>
                    {forceShowAllCards ? (
                        <img src="./card_set/cardback_blue.png" alt="" />
                    ) : (
                        <img src="./card_set/sk.png" alt="" />
                    )}
                </div>
            )}
        </footer>
    );
};
